import { useEffect, useCallback, useState, useRef } from 'react';

export function useGeoLocation(): [coords: ICoordinate | null, error: boolean] {
  const [coords, setCoords] = useState<ICoordinate | null>(null);
  const [error, setError] = useState(false);
  const options = useRef({
    enableHighAccuracy: true,
    maximumAge: 0,
    timeout: 8000,
  });

  const onSuccess = useCallback((position) => {
    setCoords({
      lat: position.coords.latitude,
      lng: position.coords.longitude,
    });
  }, []);

  const onError = useCallback(() => {
    setError(true);
  }, []);

  useEffect(() => {
    const provider = typeof navigator !== 'undefined' ? navigator.geolocation : null;
    if (provider) {
      provider.getCurrentPosition(onSuccess, onError, options.current);
    }
  }, [onError, onSuccess]);

  return [coords, error];
}
